enum RobloxLocale {
  English = 'en_us',
  Spanish = 'es_es',
  French = 'fr_fr',
  German = 'de_de',
  Italian = 'it_it',
  BrazilPortuguese = 'pt_br',
  Korean = 'ko_kr',
  SimplifiedChinese = 'zh_cn',
  SimplifiedChineseJV = 'zh_cjv',
  TraditionalChinese = 'zh_tw',
  Japanese = 'ja_jp',
  Russian = 'ru_ru',
  Indonesian = 'id_id',
  Polish = 'pl_pl',
  Vietnamese = 'vi_vn',
  Turkish = 'tr_tr',
  Arabic = 'ar_001',
  Thai = 'th_th',
}

export default RobloxLocale;
